<template>
    <div class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>委外入库-汇总</div> 
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>委外入库-明细</div> 
            </div>
        </div>
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <out-two></out-two>
        </div>
        <div v-show="actitem=='one'" style=" background:white;line-height:30px;border-bottom:2px solid #389">
            <div style="padding-top:3px;display:flex;width:1400px;  ">
                <div style="width:80px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false"  ><span style="font-size:13px; ">新增</span></el-link>
                </div>
                <el-checkbox @change="chkChg" style=" font-size:12px;margin-right:20px;" label="全选" true-label="Y" false-label="N" v-model="v_stkall"></el-checkbox>
                <span style="font-size:12px;margin-right:10px;">字段</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:130px; " >
                    <span v-for="item in poCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:310px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:110px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input> 
        
                <div style="width:110px; line-height:30px;margin-left:5px" >
                    <el-button size="mini" :disabled="editBool"  @click="nextGen" type="danger" icon="iconfont icon-xiashuangjiantou"><span style="font-size:12px;">下推应付单 </span></el-button> 
                </div>
            </div>
        </div>  
        <el-table v-show="actitem=='one'" :data="poData"
              border                            
              size="small"
              show-summary
              :summary-method="tabSummary"
              v-loading="v_loading"
              :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              class="custom-table-border"
              ref="refstk"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed>
                  <template slot="header"  >
                    <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                        <el-tooltip content=" 清除条件" effect="light">
                            <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                        </el-tooltip>
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column  v-for="(item ,index) in poCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :align="item.align"   :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        
                        <el-select v-if="item.key=='STFG'" v-model="v_row[item.key]"  size="mini" @change="inputQry" placeholder="请选择"  clearable style="width:100%">
                            <el-option label="未审核" value="N"></el-option>
                            <el-option label="已审核" value="Y"></el-option>
                        </el-select>  
                        <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  placeholder="数字框" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'||item.key=='SEL'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark"  >已审核</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark"  >未审核</el-tag>  
 
                        <el-checkbox disabled true-label="Y" false-label="N" v-model="scope.row[item.key]" v-else-if="item.edcss=='checkbox' &&item.key!=='SEL'"></el-checkbox>
                        <el-checkbox :disabled="scope.row['FINVNO'] ==null||scope.row['FINVNO']==undefined" true-label="Y" false-label="N" v-model="scope.row[item.key]" v-else-if="item.key=='SEL'"></el-checkbox>
                        <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                    </template>
                </el-table-column>
 
            </el-table-column>  
             <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="210">
                <template slot-scope="scope">
   
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>    
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="editRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y'" >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'X',scope.$index)" :underline="false"  ><span style="font-size:12px; ">作废</span></el-link>
                    </span>
 
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div v-show="actitem=='one'" style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in poCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select size="medium" filterable  v-else-if="item.key==='SUPNO' " v-model="poRow[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in supArr " :key="index">
                                    <el-col :span="6">
                                        <el-option  :label="item.SUPTYNM" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="18">
                                        <el-option  :label="item.SUPNM" :value="item.IDNO"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag" @focus="inputBtn('','', item.key)" v-else-if="item.edcss=='button'"   v-model="poRow[item.key]" style="width:100%"> </el-input>  
                            <el-select size="medium" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar">
                    <span class="spanRow"> 入库明细 </span>
                    <span style="margin-left:10px">
                        【<i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="addDtl" :underline="false" style="color:#fff"><span style="font-size:13px;margin-right:15px;border-bottom:1px solid #fff">新增明细</span></el-link>  】 
                    </span>
                </div>
                <el-table  :data="dtlData" 
                    border            
                    class="custom-table-border"                
                    size="small"
                    style="min-height:400px;margin-top:-8px"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    cell-class-name="clearPadding"
                    show-summary
                    :summary-method="getSummary"
                    ref="refdtl"
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='checkbox'&&item.sortable=='N'"
                        :min-width="item.width">  
                        <template slot="header">
                            <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                            <span v-else >{{item.title}}</span>
                        </template>                 
                        <template slot-scope="scope">                
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @input="qtyAmt(scope.row,scope.$index  )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input>                                             
                                <el-input readonly  @focus="inputBtn(scope.row,scope.$index,item.key)"   v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template> 
                    </el-table-column>    
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:11px;margin-right:6px;">删除 </span></el-link>
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :underline="false"  @click="qryStkLog(scope.row  )"><span style="font-size:11px;margin-right:2px;">查库存</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow">上传附件</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        :disabled="saveFlag"
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','gif','tiff','pdf' ]"
                        :max-size="4096"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:180px;height:140px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:180px;height:140px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="height:25px;background:#e8eaec;width:180px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" style=" font-size:10px" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('pdf')>-1" :underline="false" style="margin-right:2px;font-size:10px" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> 提示：订单审核后不能再编辑 , 如需编辑请弃审</i> 
                    <span style="margin-right:20px;">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
 
        <!-- 查看库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="logWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">库存日志</span>
            </div> 
            <div style="height:91vh;overflow-y:auto"><stklog v-bind:toolFlag="toolFlag"  v-bind:v_cond="qryCond"></stklog></div>
        </el-dialog>
  
        <!-- 下推费用明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="finWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推明细</span>
            </div> 
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selPay" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px;font-size:12px"><span style="font-size:12px;color:white">全选</span></el-checkbox>
                <span style="margin-left:6px">字段</span>
                <el-select v-model="selparam4"  placeholder="请选择列名"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryFee" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryFee" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextPay" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">下推选择记录</el-button>
            </div>
            <el-table  :data="payData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                class="custom-table-border"
                :row-key="getPayKey"
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                :height="400" 
                ref="refnext"
                v-loading="v_loading3"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                @row-click="nextClick"
                :row-class-name="tabRowClass"
                cell-class-name="clearPadding"
                highlight-current-row >
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='PRC'||item.key=='ACTQTY' " @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-input v-else-if="item.key=='RMK'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                class="custom-table-border"
                ref="refpay"
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                highlight-current-row > 
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"   type="text" icon="el-icon-close" @click="payDel(scope.row,scope.$index)">删除</el-button>   
                    </template>
                </el-table-column>
            </el-table>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="finWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button @click="genPay" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成应付单 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import stklog from './prd_stklog.vue'
import repWin from '../datamgt/repWin.vue'  
import pubWin from '../datamgt/pubwin.vue'  
import outTwo from './prdin_ww_two.vue'
export default {
    name:'stk_PRDWW_ONE',
    data () {
        return {
            maxHeight:'',
            finWin:false,
            sendVal:'PRD',
            toolFlag:false,
            logWin:false,
            qryCond:'',
            dtlRow:{},

            selPrdWin:false,
            comboArr:[],
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            actitem:'one',
            rowDtl:{},
            delPrdArr:[],
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            v_row:{},
            selparam:'IDNO',
            txtparam:'',
            t_loading:false,
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_stkall:'N',
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            options: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            supArr:[],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            poCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            stfgBool:true,
            colorx:'#e00e66', //作废颜色
            v_idseq: '',
            dtlIndex:'',
            notNull:[],
            selAll:'N',
            payData:[],
            txtparam4:'',
            selparam4:'',
            oper4:'like',
            stkCol:[],
            v_loading3:false,
            nextData:[],
            v_loginurl:'xuper_auth/getTableRecMany', //api请求路径
            chkIndex: 0,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            delImg:[],
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
            Accept: "png,jpg,jpeg,gif,tiff,pdf", //上传文件格式限制 'jpg','jpeg','png','gif','tiff'
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            prodCol:[],
            v_tabRow:{},
            v_tabIndex:'',
            v_table:'',
            tableCol :[],
            v_key:'',
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            ordCol:[],
            v_seq:'',
        }
    },
    components: {
      stklog,
      repWin,
      pubWin,
      outTwo,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 193) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 490) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
    },
    mounted () {
        this.showkey()
        this.maxHeight = document.documentElement.clientHeight - 560
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','458391','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        //供应商
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        });
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','458391','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_loginurl,'v_sys_form_fld','idseq','458391','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getStkList('') //成品入库单查询   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        itemClick(val){
            this.actitem =val     
        },
        chkChg(val){
            this.poData.forEach(item=>{
                if (item['FINVNO'])
                item['SEL'] =val
            })
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getStkList('')
        } ,
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.poCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            this.getStkList(v_cond+cond_)
        },
        addDtl(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            this.dtlData.push(v_row)
            this.delDtlArr=[]
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_orditm'
                this.tableCol =this.ordCol
                //this.v_table ='v_bs_mat'
                //this.tableCol =this.prodCol
                this.v_key2 ='stfg'
                this.v_value2 = 'N'
                this.btnWin =true
            }else if (key =='ORDNO'){ // 销售订单
                this.v_table ='v_orditm'
                this.tableCol =this.ordCol
                this.v_key2 ='ordstfg'
                this.v_value2 ='Y'
                this.btnWin =true
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['MATNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM'],REFIDNO:obj['IDNO'],POQTY:obj['QTY'],REFIDSEQ:obj['IDSEQ'] ,REFLSTSEQ:obj['LSTSEQ'],TAXPRC:obj['PRC'],AMT:obj['AMT'],TAX:obj['RATENUM'] } ))
            }else{
                Object.assign(this.poRow,{ORDNO:obj['IDNO'] })     
            } 
            this.btnWin =false
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,IMGPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
         //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择正确的图片格式 '
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                  
        },
        nextClick(row){
            this.chkIndex =row.index
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='ACTQTY' ){
                
                row['PAYAMT']= (Number(row['ACTQTY'])*Number( row['PRC'])).toFixed(2)        
            }
        },
        qtyAmt(row,index ){
            if (row['TAXPRC'] ){
                row['AMT']= (Number(row['ACTQTY'])*Number( row['TAXPRC'])).toFixed(2)        
            }
        },
        payDel(row,index){
            this.payData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        qryFee(){
            if (this.v_idseq){
                this.getFeeNext(this.v_seq )
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.payData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refnext'].setCurrentRow(this.payData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refnext'].setCurrentRow(this.payData[this.chkIndex])
                } 
            }                    
        },
        //下推
        nextGen(row,index){
            this.v_seq =''
            this.nextData=[]
            this.poData.forEach(item=>{
                if (item['SEL']=='Y'){
                    if (this.v_seq ){
                        this.v_seq =this.v_seq+',\''+item['IDSEQ']+'\''
                    }else{
                        this.v_seq ='\''+item['IDSEQ']+'\''
                    }
                }
            })
            if (!this.v_seq){
                this.promptWin =true
                this.prompt ='请选择入库单记录'
            }else{
                this.selAll='N'
                this.finWin =true
                this.getFeeNext(this.v_seq) 
            }
        },
        getFeeNext(idseq){
            let cond_=''
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.txtparam4+'%\' '
                }else{
                    cond_=cond_+' and '+this.selparam4  +this.oper4+' \''+this.txtparam4+'\' '
                }
            }
            this.payData=[]
            this.v_loading3 =true
            cond_ =cond_ + ' and idseq in (' +idseq +')'
            getTabColOrData(this.v_loginurl,'v_IC_STKDTL_qry','','','','','','',cond_).then((res) => {    
                this.payData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refpay'].doLayout()
                    this.v_loading3 =false
                })
            })
        },
        //生成应付单
        genPay(){
            let v_qtyFlag =false  
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt ='下推的记录不能为空' 
            }else{
                this.nextData.some(item=>{
                    if (!item['PAYAMT'] ||item['PAYAMT']==0 ){
                        v_qtyFlag =true
                    }
                })
                if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt ='请检查下推记录：金额>0'
                }else {
                    this.$confirm('你确定要下推生成应付单吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action ='OUT'+this.v_username+getDate('full')
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/next_genpay',
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: '成功',
                                    message: '已成功下推应付单，请到费用报销单界面中查看',
                                    type: 'success'
                                });
                            }else{
                                this.promptWin =true
                                this.prompt ='下推失败！'+res.result
                            }
                            this.finWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        nextPay(){    
            if (this.payData.filter(item=>item.SEL=='Y').length >0) {
                this.payData.filter(item=>item.ISNEXT=='N').forEach((item,index)=>{
                    if (item.SEL=='Y'){    
                        item['ISNEXT']='Y'
                        this.payData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                        this.nextData.push(JSON.parse(JSON.stringify(item)))
                    }            
                })
            }else{
                this.promptWin =true
                this.prompt ='请选择记录'
            }
        },
        selPay(){
            this.payData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT'||column.property==='ACTQTY' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        tabSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT'||column.property==='DTLAMT'||column.property==='CHKAMT' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'458391',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //查看库存
        qryStkLog(row){
            this.logWin=true
            this.qryCond=' and matno=\''+row.MATNO+'\''
        },
 
        //入库明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'v_IC_STKdtl_qry','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs['refdtl'].doLayout()
                    this.t_loading=false
                }) 
            })
            
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout();
            }) 
        },
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {               
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            this.delDtlArr=[]
            this.delImg =[]
            //入库明细
            this.getDtlList(row.IDSEQ)
            this.qryImgData(row.IDSEQ)
            this.addWin=true      
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) { 
                let v_matFlag=false,v_qtyFlag =false
                //汇总明细金额
                this.dtlData.forEach(item=>{
                    if (!item['MATNO']){
                        v_matFlag =true
                    }
                    if (!item['ACTQTY']){
                        v_qtyFlag =true
                    }
                })
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt ='明细资料不能为空'
                }else if (v_matFlag){
                    this.promptWin =true
                    this.prompt ='明细资料中产品编码不能为空'
                }else if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt ='明细资料中入库数量不能为空'
                }else {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid})), p_table:'IC_STK',frmid:'458391'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、入库明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }
                            })
                            //console.log(JSON.stringify(this.delDtlArr))
                            //入库明细删除
                            if (this.delDtlArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delDtlArr), p_table:'IC_STKdtl',p_idseq:idseq_,p_action:'D' },
                                })
                            } 
                            //3、图片保存
                            for(var k=0;k<this.imgData.length;k++){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                                })
                            }  
                            //图片删除处理
                            for(let k=0;k<this.delImg.length;k++){
                                let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['IMGPATH'],p_table:'mat_img'},
                                }).then(res=>{          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                })      
                            }   
                            this.delImg=[]
                            this.addWin =false   
                            this.stfgChange()
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
 
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'PRDIN'}
            this.dtlData=[]
            this.delDtlArr=[]
            this.imgData=[] 
            this.saveFlag=false
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getPayKey(row){
            return row.index
        },
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                v_comm='审核'
            }else if (val==='N'){
                v_comm='弃审'
            }else if (val==='X'){
                v_comm='作废'
            }
            if (val=='Y'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond:v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {
                        if (val=='X'){
                            this.poData.splice(index,1)
                        }else{        
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                        }
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
        //状态查询
        stfgChange(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            this.getStkList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(()=>{
                this.$refs['refstk'].doLayout()
            })
        },
 
        //报价单 
        getStkList(cond){
            let vm =this
            this.v_loading =true
            getTabColOrData(this.v_url,'V_IC_STK_OUTIN','IDTY','PRDIN','CORPID',this.v_corpid,'','',cond +' ORDER BY IDNO DESC').then((res) => { 
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.initPage() 
                    this.v_loading =false
                }) 
                
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','458391','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','458391','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','458391','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
 
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        width: 32%;
        height:20px !important;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
